<template>
    <div>
        <h5 v-if="!!title">{{ title }}</h5>
        <div class="mb-3">
            <app-web-cam @input="takePhoto" :multiple="multiple"></app-web-cam>
        </div>
        <!-- <input
            v-if="cameraStatus === 'off'"
            type="file"
            name="files"
            accept="image/*"
            class="file-input"
            @change="setFile($event.target.files)"
            multiple
        />-->
        <b-form-file
            v-if="cameraStatus === 'off'"
            type="file"
            name="files"
            class="file-input"
            @change="setFile($event.target.files)"
            multiple
            placeholder="Seleccione Fotos o Archivos"
        ></b-form-file>
        <div class="file-list alert alert-info mt-2" v-if="!!files.length && cameraStatus == 'off'">
            <h5>Archivos seleccionados</h5>
            <div
                class="file-item"
                v-for="(file, index) in files"
                :key="index"
            >{{ index + 1 }} - {{ file.name }}</div>
        </div>
        <div class="form-row" v-if="cameraStatus === 'on'">
            <button
                v-if="cameraStatus === 'on'"
                :disabled="!photos.length"
                class="btn btn-success btn-block"
                @click.prevent="savePhotos"
            >Confirmar Fotos</button>
            <button
                v-if="cameraStatus === 'on'"
                class="btn btn-secondary btn-block"
                @click.prevent="cancel"
            >Cancelar</button>
        </div>
    </div>
</template>
<script>
// import VueWebcam from 'vue-webcam';
import WebCam from '../WebCam/WebCam.vue'
export default {
    components: {
        // vueWebcam: VueWebcam,
        appWebCam: WebCam,
    },

    props: {
        title: {
            type: String,
            default: '',
        },
        id: {
            type: String,
            default: () => {
                return `uploadphoto-${parseInt(Math.random() * 100)}`
            },
        },
        multiple: {
            type: Boolean,
            default: () => true,
        },
    },
    data() {
        return {
            photo: '',
            photos: [],
            files: [],
            cameraStatus: 'off',
            file: '',
        }
    },

    methods: {
        savePhotos() {
            this.cameraStatus = 'off'
            toastr.success('Fotos guardadas correctamente')
        },
        // deletePhoto(index){
        //     this.photos.splice(index, 1);
        //     this.$emit('input', {
        //         files: this.files,
        //         photos: this.photos
        //     });
        // },
        // cameraOn(){
        //     this.$bus.$emit('camera-window.open');
        //     this.cameraStatus = 'on';
        // },
        // cameraOff(){
        //     this.cameraStatus = 'off';
        // },
        takePhoto(photos) {
            this.photos = photos.slice(0)
            this.$emit('input', {
                files: this.files,
                photos: this.photos,
            })
        },
        // takePicture(){
        //     this.photos.push(this.$refs.webcam.getPhoto());
        //     this.$emit('input', {
        //         files: this.files,
        //         photos: this.photos
        //     });
        // },
        cancel() {
            this.cameraStatus = 'off'
            this.photos = []
            this.$emit('input', {
                photos: this.photos,
            })
        },
        setFile(files) {
            if (Object.keys(files).length > 0) {
                Object.keys(files).map(key => this.files.push(files[key]))
                this.$emit('input', {
                    files: this.files,
                    photos: this.photos,
                })
                $(`.file-input`).val('')
            }
        },
        clear() {
            this.photos = []
            this.files = []
            this.$bus.$emit('reset-photos')
            this.$bus.$emit('webcam.off')
            this.cameraStatus = 'off'
            this.file = ''
            this.photo = ''
            $(`.file-input`).val('')
            this.$emit('input', {
                files: this.files,
                photos: this.photos,
            })
        },
    },

    created() {
        this.$bus.$on(`${this.id}.clean`, this.clear)
        // this.$bus.$on(`${this.id}.camera-off`, this.cameraOff);
        this.$bus.$emit('webcam.off')
    },
}
</script>

<style scoped>
.avatarview img {
    height: 150px;
    width: 225px;
    border-radius: 8px;
    border: 2px solid #c7ced5;
    padding: 3px;
    margin-bottom: 10px;
}
</style>
